import { gql } from '@apollo/client';

const EXTERNAL_ID_FRAGMENT = gql`
  fragment BaseExternalId on ExternalId {
    sourceId
    sourceKind
  }
`;

export default EXTERNAL_ID_FRAGMENT;
